import React from "react";
import AdminHeader from "../../_components/AdminHeader/AdminHeader";
import AdminSidebar from "../../_components/AdminSidebar/AdminSidebar";
import ConfirmationAlert from "../../_components/ConfirmationAlert/ConfirmationAlert";
import authenticationService from "../../_services/authentication.service";
import userService from "../../_services/user.service";

class UpdateProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true,
      isModelOpen: false,
      user: authenticationService?.currentUserValue,
      errors: {},
      isFormValid: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleChange(event) {
    const { name, value } = event.target;
    const { user, errors } = this.state;

    const re = /^[0-9\b]+$/;
    if (name === "contact") {
      if (value === "" || re.test(value)) {
        this.setState({
          user: {
            ...user,
            [name]: value,
          },
          errors: {
            ...errors,
            [name]: "",
          },
        });
      } else {
        this.setState({
          errors: {
            ...errors,
            [name]: "Only numbers are allowed",
          },
        });
      }
    } else {
      this.setState({
        user: {
          ...user,
          [name]: value,
        },
        errors: {
          ...errors,
          [name]: "",
        },
      });
    }
  }
  handleSubmit() {
    if (this.validateForm()) {
      const { user } = this.state;
      user.enabled = true;
      let formData = JSON.stringify(user);
      userService
        .update(formData)
        .then((data) => this.responseShow(data))
        .catch((error) => console.log("Error :" + error));
    }
  }
  responseShow(obj) {
    const { user } = this.state;
    if (obj.isSuccess) {
      let userCurrent = authenticationService?.currentUserValue;
      console.log(userCurrent);
      userCurrent.firstName = user?.firstName;
      userCurrent.lastName = user?.lastName;
      userCurrent.contact = user?.contact;
      authenticationService.updateLocalStorage(userCurrent);
    }
    this.handleResetForm();
    let alertMember = {
      show: true,
      isAnimate: false,
      ariaLabelledby: "",
      title: "Confirmation",
      message: obj.message,
      buttons: [
        {
          label: "Close",
          onClick: this.handleNo,
          cssclass: "btn btn-danger btn-sm ts-buttom",
        },
      ],
    };
    this.setState({ isModelOpen: true, alertMember: alertMember });
  }

  handleNo = (e) => {
    this.setState({ isModelOpen: false });
  };

  handleResetForm() {
    this.setState({
      isOpen: true,
      isModelOpen: false,
      user: authenticationService?.currentUserValue,
      errors: {},
      isFormValid: false,
    });
  }
  validateForm() {
    let { user } = this.state;
    let errors = {};
    let isFormValid = true;

    if (!user?.firstName) {
      isFormValid = false;
      errors["firstName"] = "Enter First Name";
    }
    if (!user?.lastName) {
      isFormValid = false;
      errors["lastName"] = "Enter Last Name";
    }

    if (!user?.contact) {
      isFormValid = false;
      errors["contact"] = "Enter Contact No";
    }

    this.setState({
      errors: errors,
    });
    return isFormValid;
  }
  handleClick = (e) => {
    this.setState({ isOpen: !this.state?.isOpen });
  };
  render() {
    const { user } = this.state;
    const showClass = `page-wrapper chiller-theme ${
      this.state?.isOpen ? "toggled" : ""
    }`;
    const { isModelOpen, alertMember } = this.state;
    return (
      <React.Fragment>
        {isModelOpen ? <ConfirmationAlert {...alertMember} /> : null}
        <div className={showClass}>
          <AdminHeader />
          <AdminSidebar handleClick={this.handleClick} />
          <main className="page-content">
            <div className="container-fluid">
              <h4 className="text-left">Update Profile</h4>
              <hr className="hr" />
              <div className="row">
                <div className="col-sm-12">
                  <div className="box box-primary">
                    <form name="form">
                      <div className="box-body">
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="firstName">First Name</label>
                              <input
                                id="firstName"
                                name="firstName"
                                value={user?.firstName}
                                onChange={this.handleChange}
                                maxLength="20"
                                type="text"
                                className={
                                  "form-control" +
                                  (this.state?.errors?.firstName
                                    ? " invalid"
                                    : "")
                                }
                                placeholder="First Name"
                              />
                              {this.state?.errors?.firstName && (
                                <small class="help-block">
                                  {this.state?.errors?.firstName}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="lastName">Last Name</label>
                              <input
                                id="lastName"
                                name="lastName"
                                value={user?.lastName}
                                onChange={this.handleChange}
                                maxLength="20"
                                type="text"
                                className={
                                  "form-control" +
                                  (this.state?.errors?.lastName
                                    ? " invalid"
                                    : "")
                                }
                                placeholder="Last Name"
                              />
                              {this.state?.errors?.lastName && (
                                <small class="help-block">
                                  {this.state?.errors?.lastName}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label htmlFor="contact">Contact No</label>
                            <input
                              id="contact"
                              name="contact"
                              value={user?.contact}
                              onChange={this.handleChange}
                              maxLength="10"
                              type="text"
                              className={
                                "form-control" +
                                (this.state?.errors?.contact ? " invalid" : "")
                              }
                              placeholder="Contact No"
                            />
                            {this.state?.errors?.contact && (
                              <small class="help-block">
                                {this.state?.errors?.contact}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12 text-left">
                          <button
                            type="button"
                            onClick={this.handleSubmit}
                            className="btn btn-primary"
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </React.Fragment>
    );
  }
}
export default UpdateProfile;
